/* eslint-disable
    array-callback-return,
    func-names,
    no-prototype-builtins,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular
  .module('bench.ui.form.textarea', deps)

  .directive('blTextarea', ($compile, _) => {
    let $$id = 0;

    return {
      restrict: 'E',
      template(elem, attrs) {
        const $id = $$id++;
        const id = `bl-textarea-${$id}`;

        _.defaults(attrs, {
          name: _.camelCase(attrs.label),
          id,
        });

        const textareaAttrs = _(
          [
            'id',
            'name',
            'ng-model',
            'value',
            'readonly',
            'ng-readonly',
            'step',
            'msd-elastic',
            'maxlength',
          ].map(attr => {
            if (attrs.hasOwnProperty(_.camelCase(attr))) {
              const attrVal = attrs[_.camelCase(attr)];
              elem.removeAttr(attr);
              if (!_.isEmpty(attrVal)) {
                return `${attr}=\"${attrVal}\"`;
              }
              return attr;
            }
          }),
        )
          .compact()
          .join('\n');

        return `\
<textarea ${textareaAttrs}></textarea>
<label
    for="${id}"
    placeholder="${attrs.label}"
    alt="${attrs.label}">
</label>\
`;
      },

      link(scope, elem, attrs) {
        const $textarea = elem.find('textarea');

        const toggleClasses = function () {
          if ($textarea.val().length === 0) {
            $textarea.addClass('empty');
            return $textarea.removeClass('non-empty');
          }
          $textarea.addClass('non-empty');
          return $textarea.removeClass('empty');
        };

        // watch for changes and toggle empty/non-empty classes
        if (attrs.ngModel != null) {
          return scope.$watch(attrs.ngModel, toggleClasses);
        }
        return $textarea.on('keyup change', toggleClasses);
      },
    };
  });
